import { render } from "./NavIcon.vue?vue&type=template&id=5003bc50&scoped=true"
import script from "./NavIcon.vue?vue&type=script&lang=js"
export * from "./NavIcon.vue?vue&type=script&lang=js"

import "./NavIcon.vue?vue&type=style&index=0&id=5003bc50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5003bc50"]])

export default __exports__